import { render, staticRenderFns } from "./ModifyWanatelPackageModal.vue?vue&type=template&id=4e562366&"
import script from "./ModifyWanatelPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyWanatelPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports